import { collection, doc, getDoc, getDocFromServer, getDocs, limit, orderBy, query, runTransaction, serverTimestamp, setDoc, startAfter, where } from 'firebase/firestore';
import { auth, db } from '../libs/firebaseConfig';
import { contentError, PAGE_SIZE, validTestId } from './pretestModel';
const tests = () => collection(db, 'pretests');
const sheet = (uid, id) => doc(db, 'users', uid, 'pretestSubmissions', id);
const row = snap => ({ ...snap.data(), id: snap.id });
function requireUser(uid) { if (!uid || auth.currentUser?.uid !== uid) throw new Error('บัญชีเปลี่ยนแล้ว กรุณาเข้าสู่ระบบใหม่ก่อนบันทึก'); }
export const pretestApi = {
  async list({ courseId = '', admin = false, status = 'all', cursor = null, pageSize = PAGE_SIZE } = {}) {
    const parts = [];
    if (!admin || status !== 'all') parts.push(where('isActive', '==', !admin || status === 'active'));
    if (courseId) parts.push(where('courseId', '==', courseId));
    parts.push(orderBy('createdAt', 'desc'));
    if (cursor) parts.push(startAfter(cursor));
    parts.push(limit(pageSize));
    const snap = await getDocs(query(tests(), ...parts));
    return { items: snap.docs.map(row), next: snap.size === pageSize ? snap.docs[snap.docs.length - 1] : null };
  },
  async get(id) {
    if (!validTestId(id)) return null;
    const snap = await getDoc(doc(db, 'pretests', id));
    return snap.exists() ? row(snap) : null;
  },
  async courses() {
    const snap = await getDocs(collection(db, 'courses'));
    return snap.docs.map(row).sort((a, b) => String(a.title || '').localeCompare(String(b.title || ''), 'th'));
  },
  async course(id) { const snap = await getDoc(doc(db, 'courses', id)); return snap.exists() ? row(snap) : null; },
  async save({ id, courseId, content, isActive, version = null }) {
    if (!validTestId(id)) throw new Error('ลิงก์ต้องเป็น a–z, 0–9 และขีดกลาง ไม่เกิน 80 ตัวอักษร');
    const error = contentError(content); if (error) throw new Error(error);
    if (!courseId) throw new Error('กรุณาเลือกคอร์ส');
    await runTransaction(db, async tx => {
      const ref = doc(db, 'pretests', id);
      const current = await tx.get(ref);
      const course = await tx.get(doc(db, 'courses', courseId));
      if (!course.exists()) throw new Error('ไม่พบคอร์สที่เลือก กรุณาเลือกใหม่');
      if (version === null && current.exists()) throw new Error('ลิงก์นี้ถูกใช้แล้ว กรุณาเลือกลิงก์อื่น');
      if (version !== null && (!current.exists() || current.data().version !== version)) throw new Error('ข้อสอบถูกแก้ไขจากหน้าต่างอื่น กรุณาโหลดข้อมูลล่าสุดก่อนแก้ไข');
      const data = { courseId, content, isActive: !!isActive, version: (version || 0) + 1, updatedAt: serverTimestamp() };
      if (!current.exists()) data.createdAt = serverTimestamp();
      if (current.exists()) tx.update(ref, data); else tx.set(ref, data);
    });
  },
  async setActive(test, isActive) {
    await runTransaction(db, async tx => {
      const ref = doc(db, 'pretests', test.id); const snap = await tx.get(ref);
      if (!snap.exists() || snap.data().version !== test.version) throw new Error('ข้อสอบถูกแก้ไขแล้ว กรุณาโหลดรายการใหม่');
      if (isActive) { const error = contentError(snap.data().content); if (error) throw new Error(error); }
      tx.update(ref, { isActive, version: test.version + 1, updatedAt: serverTimestamp() });
    });
  },
  newSubmissionId(uid) { requireUser(uid); return doc(collection(db, 'users', uid, 'pretestSubmissions')).id; },
  async submit(uid, id, result) {
    requireUser(uid);
    const ref = sheet(uid, id);
    // Recover an acknowledged-but-lost response without overwriting an immutable attempt.
    const existing = await getDocFromServer(ref);
    requireUser(uid);
    if (existing.exists()) return row(existing);
    await setDoc(ref, { ...result, createdAt: serverTimestamp() });
    return { ...result, id };
  },
  async submission(uid, id) { requireUser(uid); const snap = await getDoc(sheet(uid, id)); return snap.exists() ? row(snap) : null; },
  async submissions(uid, cursor = null) {
    requireUser(uid);
    const parts = [orderBy('createdAt', 'desc')]; if (cursor) parts.push(startAfter(cursor)); parts.push(limit(PAGE_SIZE));
    const snap = await getDocs(query(collection(db, 'users', uid, 'pretestSubmissions'), ...parts));
    return { items: snap.docs.map(row), next: snap.size === PAGE_SIZE ? snap.docs[snap.docs.length - 1] : null };
  },
};
